// frontend/src/hooks/useDragScroll.js
import { useRef, useEffect } from 'react';

// Makes a horizontally-scrolling row (overflow-x-auto) scrollable with a plain
// desktop mouse — click-and-drag, plus a vertical wheel gesture translated to
// horizontal scroll. Native touch scrolling on mobile already works without
// this; it only fills the gap on desktop, especially with `scrollbar-hide`
// hiding the one thing a mouse user could otherwise drag.
export default function useDragScroll() {
  const ref = useRef(null);
  const dragging = useRef(false);
  const startX = useRef(0);
  const scrollLeft = useRef(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const handler = (e) => { e.preventDefault(); el.scrollLeft += e.deltaY; };
    el.addEventListener('wheel', handler, { passive: false });
    return () => el.removeEventListener('wheel', handler);
  }, []);

  const onMouseDown = (e) => {
    if (!ref.current) return;
    dragging.current = true;
    startX.current = e.pageX - ref.current.offsetLeft;
    scrollLeft.current = ref.current.scrollLeft;
    ref.current.classList.add('dragging');
  };
  const onMouseLeave = () => { dragging.current = false; ref.current?.classList.remove('dragging'); };
  const onMouseUp = () => { dragging.current = false; ref.current?.classList.remove('dragging'); };
  const onMouseMove = (e) => {
    if (!dragging.current || !ref.current) return;
    e.preventDefault();
    const x = e.pageX - ref.current.offsetLeft;
    ref.current.scrollLeft = scrollLeft.current - (x - startX.current);
  };

  return { ref, onMouseDown, onMouseLeave, onMouseUp, onMouseMove };
}
